import ApolloClient from "apollo-boost"

const apolloClient = new ApolloClient({
    uri: process.env.VUE_APP_GGM_BASE_URL as string,
})

export default apolloClient
